"use strict";

(function () {
  'use strict';

  function passwordResetCtrl($location, $state, LoginService, UtilsService, LRNotification, JsSHA, vcRecaptchaService) {
    var vm = this;
    vm.loading = false;
    vm.resetToken = '';
    vm.errMsg = '';
    vm.successMsg = '';
    vm.submitted = 0;
    vm.failedAttempts = 0;

    vm.setResponse = function (response) {
      vm.errMsg = '';
      console.info('response available');
      vm.gRecaptchaResponse = response;
    };

    vm.setWidgetId = function (widgetId) {
      console.info('Created widget ID: %s', widgetId);
      vm.widgetId = widgetId;
    };

    vm.cbExpiration = function () {
      console.info('Captcha expired. Resetting response object');
      vcRecaptchaService.reload(vm.widgetId);
      vm.gRecaptchaResponse = null;
    };

    this.pageTitle = 'Password Reset';
    this.buttonText = 'Reset Password';

    if ($state.current.name === 'login-complete-account-setup') {
      this.pageTitle = 'Your Account is Almost Ready!';
      this.pageSubTitle = 'Complete your account setup by creating your personal password';
      this.buttonText = 'Complete Setup';
    }

    var _errs = {
      token_expired: 'This password reset token has expired. Please try again.',
      server_error: 'There was an issue resetting your password. Please try again.',
      no_user: 'No account exists for the email address supplied. Please try again.',
      bad_email: 'Email address is not valid. Please enter a valid email and try again.',
      bad_data: 'Your request was not valid. Please try again.',
      missing_data: 'Not enough information was received to reset your password. Please try again.'
    };
    var _successMsgs = {
      email_sent: 'Password reset email sent. Please check your email for further instructions.',
      reset_successful: 'Password has been reset successfully.'
    };

    if ($state.params.reset_token) {
      this.email = window.atob($state.params.reset_token).split(':')[0];
      this.resetToken = window.atob($state.params.reset_token).split(':')[1];
    }

    if ($state.params.errMsg) {
      if (_errs.hasOwnProperty($state.params.errMsg)) {
        this.errMsg = _errs[$state.params.errMsg];
      }
    }

    if ($state.params.successMsg) {
      if (_successMsgs.hasOwnProperty($state.params.successMsg)) {
        this.successMsg = _successMsgs[$state.params.successMsg];
      }
    }

    this.sendResetEmail = function (form, email) {
      vm.submitted++;
      vm.errMsg = '';
      vm.successMsg = '';

      if (!UtilsService.Form.isValid(form)) {
        UtilsService.Form.validateForm(form);
        vm.loading = false;
      } else {
        vm.loading = true;

        if (vm.failedAttempts >= 3) {
          UtilsService.Recaptcha.validate(vm.gRecaptchaResponse).then(function (responseData) {
            if (!responseData.success) {
              vm.errMsg = 'Recaptcha verification expired. Please Try again.';
              vcRecaptchaService.reload(vm.widgetId);
            } else {
              _sendResetEmail();
            }
          }, function (error) {
            console.error(error);
            vcRecaptchaService.reload(vm.widgetId);
          });
        } else {
          _sendResetEmail();
        }
      }

      function _sendResetEmail() {
        LoginService.sendResetEmail(email.toLowerCase()).then(function (successMsg) {
          if (_successMsgs.hasOwnProperty(successMsg)) {
            vm.successMsg = _successMsgs[successMsg];
          }

          vm.loading = false;
        }, function (error) {
          if (_errs.hasOwnProperty(error)) {
            vm.errMsg = _errs[error];
          }

          if (vm.failedAttempts >= 3) {
            vcRecaptchaService.reload(vm.widgetId);
          }

          vm.failedAttempts++;
          vm.loading = false;
        });
      }
    };

    this.resetPassword = function (form, password, password2) {
      this.loading = true;
      this.errMsg = '';
      this.successMsg = '';

      if (!UtilsService.Form.isValid(form)) {
        UtilsService.Form.validateForm(form);
        vm.loading = false;
      } else {
        var shaObj = new JsSHA('SHA-256', 'TEXT');
        shaObj.setHMACKey(vm.email.toLowerCase(), 'TEXT');
        shaObj.update(password);
        var hash = shaObj.getHMAC('HEX');
        var shaObj2 = new JsSHA('SHA-256', 'TEXT');
        shaObj2.setHMACKey(vm.email.toLowerCase(), 'TEXT');
        shaObj2.update(password2);
        var hash2 = shaObj2.getHMAC('HEX');
        LoginService.resetPassword({
          password: hash,
          password2: hash2,
          token: vm.resetToken
        }).then(function (successMsg) {
          if (successMsg) {
            if ($state.current.name === 'login-complete-account-setup') {
              LRNotification.success('Account setup successfully', 3500);
            } else if (_successMsgs.hasOwnProperty(successMsg)) {
              LRNotification.success(_successMsgs[successMsg], 3500);
            }

            if ($state.params.returnto) {
              $location.path($state.params.returnto);
            } else {
              $state.go('dashboard');
            }
          } else {
            vm.errMsg = _errs['server_error'];
          }

          vm.loading = false;
        }, function (error) {
          if (_errs.hasOwnProperty(error)) {
            vm.errMsg = _errs[error];
          }

          vm.loading = false;
        });
      }
    };
  }

  passwordResetCtrl.$inject = ['$location', '$state', 'LoginService', 'UtilsService', 'LRNotification', 'JsSHA', 'vcRecaptchaService'];
  angular.module('view.login').component('passwordReset', {
    bindings: {},
    controller: passwordResetCtrl,
    templateUrl: 'views/login/components/password-reset/password-reset.html'
  });
})();